import { nodeApi } from "@/redux/api/nodeApi";

export const trialPlanApi = nodeApi.injectEndpoints({
  endpoints: (builder) => ({
    startTrial: builder.mutation({
      query: (body: { email: string }) => ({
        url: "/ai-free-trial/start",
        method: "POST",
        body,
      }),
    }),
    checkTrialStatus: builder.query({
      query: (email: string) => ({
        url: `/ai-free-trial/status?email=${email}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useStartTrialMutation, useCheckTrialStatusQuery } = trialPlanApi;
